import { Meals } from 'components/Cart/cartContext';

export const useCheckout = (meals: Meals, day: string) => {
  let totalPrice = 0;

  for (const meal of Object.values(meals)) {
    if (meal.item.price && meal.day === day) {
      totalPrice += meal.item.price * meal.quantity;
    }
  }

  const totalMealCount = Object.keys(meals).reduce((previous, key) => {
    const meal = meals[key];

    if (meal.day !== day) {
      return previous;
    }

    return previous + meal.quantity;
  }, 0);

  return {
    totalPrice,
    totalMealCount,
  };
};
